export default __webpack_public_path__ + "assets/images/ee2067b7967b047b5a22c6e1fb097b04.png";